const menu = {
    label: 'Painel Certificados',
    icon: 'pi pi-fw pi-chart-bar',
    to: '/checkins/certificados/painel',
    rules: ['CHECKINS-CERTIFICADO-00'],
};

export default menu;
